// extracted by mini-css-extract-plugin
var _1 = "SkeletonBlock_active__b4978";
var _2 = "SkeletonBlock_blockActions__0c78f";
var _3 = "SkeletonBlock_canvas__99831";
var _4 = "SkeletonBlock_center__1009e";
var _5 = "SkeletonBlock_commentActive__07659";
var _6 = "SkeletonBlock_hover__6e44c";
var _7 = "SkeletonBlock_isComment__977aa";
var _8 = "SkeletonBlock_isDone__20df2";
export { _1 as "active", _2 as "blockActions", _3 as "canvas", _4 as "center", _5 as "commentActive", _6 as "hover", _7 as "isComment", _8 as "isDone" }
